<ng-template #leagueTemplate let-item>
    <ds-divider />
    <ms-list-item
        msTrackReferringActionDirective
        [trackingValue]="trackingValue()"
        [cleanAfterTrack]="cleanedAfterTrack()"
        [title]="item.title"
        [boldTitle]="item.active"
        [icon]="item.icon"
        [href]="item.href"
        [arrow]="false"
        [count]="item.count"
        [isActive]="item.active"
        [isShowBorder]="false"
        [showStartSlot]="false"
        (itemClicked)="onTreeItemClick(item)" />
</ng-template>
<ng-template #treeCompetitionTemplate let-item>
    <ng-container *ngTemplateOutlet="leagueTemplate; context: { $implicit: item }" />
</ng-template>

@if (tree) {
    <ms-item-tree [tree]="[tree]" [class]="'all-competitions'" [leafTemplate]="treeCompetitionTemplate" (toggle)="toggled(tree, $event)" />
}
